// @flow

import React, { PureComponent } from "react";
import type { RaceTypeCodeEnum } from "@tvg/types/Race";
import { starOutlineFill, arrowDown } from "@fdr/static-ui/Icons/icons";
import { SelectIcon, StarIcon, RunnerNumberAtom } from "./styled-components";
import getColor from "./SaddleColors";

type ArrowDirectionEnum = "none" | "up" | "down";

type Props = {
  /**
   * Display the number of runner
   */
  runnerId: string,
  /**
   * Code of the race type
   */
  raceTypeCode: RaceTypeCodeEnum,
  /**
   * runner is favorite
   */
  isFavorite: boolean,
  /**
   * arrow direction, when applicable
   */
  arrowDirection: ArrowDirectionEnum,
  hasTimeformInfo: boolean,
  isBigSize: boolean,
  isRightSpaced: boolean
};

export default class RunnerNumber extends PureComponent<Props> {
  static defaultProps = {
    runnerId: "",
    raceTypeCode: "T",
    isFavorite: false,
    arrowDirection: "none",
    hasTimeformInfo: false,
    isBigSize: false,
    isRightSpaced: false
  };

  render() {
    const saddle = getColor(
      this.props.raceTypeCode,
      parseInt(this.props.runnerId, 10)
    );

    return (
      <RunnerNumberAtom
        saddleColor={saddle.saddleColor}
        numberColor={saddle.numberColor}
        gradient={saddle.gradient}
        textShadow={saddle.textShadow}
        isFavorite={this.props.isFavorite}
        border={saddle.border}
        flexDirection={this.props.arrowDirection !== "none" ? "column" : "row"}
        isRotated={this.props.arrowDirection === "up"}
        hasTimeformInfo={this.props.hasTimeformInfo}
        isBigSize={this.props.isBigSize}
        isRightSpaced={this.props.isRightSpaced}
      >
        {this.props.isFavorite && (
          <StarIcon size={9} icon={starOutlineFill} color="#ffb80c" />
        )}
        {!this.props.runnerId ? "?" : this.props.runnerId}
        {this.props.arrowDirection !== "none" && (
          <SelectIcon
            isRotated={this.props.arrowDirection === "up"}
            icon={arrowDown}
            size={12}
            color={saddle.numberColor}
          />
        )}
      </RunnerNumberAtom>
    );
  }
}
